/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsSwapH: {
  name: 'arrows-swap-h';
  data: string;
} = {
  name: 'arrows-swap-h',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.354.646a.5.5 0 0 0-.708.708L13.793 3.5H7a.5.5 0 0 0 0 1h6.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3Zm-8 8.708a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L2.207 12.5H9a.5.5 0 0 0 0-1H2.207l2.147-2.146Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
